module.exports = __webpack_public_path__ + "static/media/profile-icon.25c25f8c.png";